/**
 * Stable per-visitor identity helpers shared by Facebook + Pinterest tracking.
 *
 * - external_id: persistent UUID in localStorage (no PII)
 * - order_id:    fresh UUID per checkout event
 * - click_id:    Pinterest `_epik` / Facebook `_fbc` from cookie or URL
 */

const EXTERNAL_ID_KEY = 'ms_external_id';

const newUuid = () => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
};

export const getExternalId = () => {
    if (typeof window === 'undefined') return undefined;
    try {
        let id = window.localStorage.getItem(EXTERNAL_ID_KEY);
        if (!id) {
            id = newUuid();
            window.localStorage.setItem(EXTERNAL_ID_KEY, id);
        }
        return id;
    } catch {
        return undefined;
    }
};

export const newOrderId = () => newUuid();

const getCookie = (name) => {
    if (typeof document === 'undefined') return undefined;
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : undefined;
};

const getQueryParam = (name) => {
    if (typeof window === 'undefined') return undefined;
    try {
        return new URL(window.location.href).searchParams.get(name) || undefined;
    } catch {
        return undefined;
    }
};

export const getPinterestClickId = () => getQueryParam('epik') || getCookie('_epik');

export const getFbClickId = () => getCookie('_fbc');
export const getFbBrowserId = () => getCookie('_fbp');
